import React from 'react'
import letters from '../../../assets/images/letterTours.png'
import './Assets/styles.css'

function TourHeaderInfo() {
  return (
    <div className='tourHeaderInfo'>
        <div className='tourHeaderInfo_img'>
            <img className='imgletters' src={letters} alt='Tours' />
        </div>
        <div className='tourHeaderInfo_text'>
            <p>Disfruta de las diferentes actividades que puedes realizar en tu destino</p>
        </div>
    </div>
  )
}

export default TourHeaderInfo